import { render, staticRenderFns } from "./RecorverPassword.vue?vue&type=template&id=6d016f03&"
import script from "./RecorverPassword.vue?vue&type=script&lang=js&"
export * from "./RecorverPassword.vue?vue&type=script&lang=js&"
import style0 from "./RecorverPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports